import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';
import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import messages from './messages';
import { useFulfillmentPlannerContext } from '../../../../../../fulfillment-planner/context';
import { useSaveProductShippingData } from '../../../../../../hooks/use-save-product-shipping-data';
import { productShippingDefaultsSavedSubject } from '../../../../../../store/products/products.epic';

import style from './style.module.less';

const SaveShippingDefaultRecommendation = ({ className = '' }) => {
  const { fulfillmentPlanId, isRating } = useFulfillmentPlannerContext();
  const [defaultSaved, setDefaultSaved] = useAsyncSafeState(false);
  const { asyncSaveShippingDefaults, cswProductId, isSingleOrder, isServiceCollectionSelected } =
    useSaveProductShippingData(fulfillmentPlanId);

  useEffect(() => {
    const subscription = productShippingDefaultsSavedSubject.subscribe(({ didSaveDefaults }) => {
      if (didSaveDefaults) {
        setDefaultSaved(true);
      }
    });

    setDefaultSaved(false);
    return () => subscription.unsubscribe();
  }, [isRating, setDefaultSaved]);

  const shouldShowSaveDefaultRecommendation = isSingleOrder && cswProductId && !isServiceCollectionSelected;

  return (
    shouldShowSaveDefaultRecommendation && (
      <div className={className}>
        <div className={style['shipping-default-wrapper']}>
          <Text textType={TextType.Paragraph} value={messages.description} />
          {defaultSaved ? (
            <div className={style['shipping-default-save-success']}>
              <FontAwesomeIcon className={style['completed-icon']} icon={faCheckCircle} />
              <Text textType={TextType.Caption} value={messages.saved} />
            </div>
          ) : (
            <Button
              className={style['shipping-default-save-button']}
              disabled={isRating || defaultSaved}
              onClick={asyncSaveShippingDefaults}
              theme='tertiary'
            >
              <FormattedMessage {...messages.buttonText} />
            </Button>
          )}
        </div>
      </div>
    )
  );
};

SaveShippingDefaultRecommendation.propTypes = {
  className: PropTypes.string,
};

export { SaveShippingDefaultRecommendation };
